export default "__VITE_ASSET__01e5f5e5__"